export default function Support() {
  return (
    <div
      style={{
        maxWidth: 600,
        margin: "2rem auto",
        padding: "0 1rem",
        fontFamily: "Arial, sans-serif",
        lineHeight: 1.6,
      }}
    >
      <h1 style={{ fontStyle: "italic" }}>Get Stuffed App Support</h1>

      <p>
        Thank you for using <em>Get Stuffed</em>! If you need assistance, have
        feedback, or encounter any issues, we're here to help.
      </p>

      <h2 style={{ fontStyle: "italic" }}>Contact Us</h2>
      <p>
        📧 <strong>Email:</strong>{" "}
        <a href="mailto:Get_stuffed@yahoo.com" style={{ color: "#007bff" }}>
          Get_stuffed@yahoo.com
        </a>
      </p>
      <p>
        📞 <strong>Phone/WhatsApp:</strong>{" "}
        <a href="tel:+447477643029" style={{ color: "#007bff" }}>
          07477643029
        </a>
      </p>
      <p>
        We aim to respond within <em>24–48 hours</em>.
      </p>

      <h2 style={{ fontStyle: "italic" }}>Frequently Asked Questions (FAQs)</h2>

      <h3 style={{ fontStyle: "italic" }}>Account & Login Issues</h3>
      <p>
        🔹 Can’t log in? – Ensure your email is correctly entered or contact us.
      </p>

      <h3 style={{ fontStyle: "italic" }}>App Features & Troubleshooting</h3>
      <p>
        🔹 App crashing? – Try restarting your device or reinstalling the app.
      </p>
      <p>🔹 Feature not working? – Check for updates in the App Store.</p>

      <h3 style={{ fontStyle: "italic" }}>Feedback & Suggestions</h3>
      <p>
        We’d love to hear from you! Email us your ideas to improve{" "}
        <em>Get Stuffed</em>.
      </p>
    </div>
  );
}
